import React, { Component } from 'react'
import Swiper from 'react-slider-swiper'
import firebase from 'firebase'
import { find } from 'lodash'
import moment from 'moment'
import Lines from '../Lines'

import './styles/ObjectsSectionStyles.css'

class ObjectsSection extends Component {
    constructor(props) {
        super(props)

        this.state = {
            title: '',
            descr: '',
            objects: []
        }
    }

    componentDidMount() {

        const dbRef = firebase.database().ref('sections/ObjectsSection')
        const objRef = firebase.database().ref('objects')

        dbRef.on('value', this.setData.bind(this))
        objRef.on('value', this.setObjData.bind(this))
    }

    setData(snapshot) {
        const data = snapshot.val()

        if (data) {
            this.setState({
                ...data
            })
        }
    }

    setObjData(snapshot) {
        const data = snapshot.val()

        if (data) {

            const objects = []

            for (let key in data) {
                const item = data[key]
                if (!item.isReady && item.isVisible) {
                    objects.push(data[key])
                }
            }

            this.setState({
                objects: objects
            })
        }
    }

    getPhoto(item) {
        if (item.photo && item.photo.length) {
            const photo = find(item.photo, { isMain: true })
            if (photo) {
                return photo.thumbUrl ? photo.thumbUrl : photo.url
            } else {
                return item.photo[0].thumbUrl ? item.photo[0].thumbUrl : item.photo[0].url
            }
        } else {
            return ''
        }
    }

    getObjectSlide() {
        return this.state.objects.map((item, i) => {

            return (
                <div key={`Object${i}`} id={item.id} className="ObjectsSectionSlide" >
                    <div style={{ backgroundImage: `url("${this.getPhoto(item)}")` }} className="ObjectsSectionSlideContent">
                        <div className="ObjectsSectionSlideContentWrapper">
                            <div className="ObjectsSectionSlideContentTitle">
                                {item.title}
                            </div>
                            <div className="ObjectsSectionSlideContentPlace">
                                {item.address}
                            </div>
                        </div>
                    </div>
                </div>
            )
        })
    }

    render() {
        const now = moment().format('x')
        return (
            <div className="ObjectsSectionWrapper">
                <div className="ObjectsSectionContent">
                    <div className="ObjectSectionTitle columns is-mobile">
                        <h2 className="column is-11 is-offset-1">{this.state.title}</h2>
                    </div>
                    <div className="ObjectSectionDescription columns is-mobile">
                        <p className="column is-5 is-offset-1">{this.state.descr}</p>
                    </div>
                    <div className="ObjectsSectionSlider column is-12">
                        {(this.state.objects.length > 0) ? (
                            <Swiper
                                key={`ObjectsSwiper${now}`}
                                pagination={'.ObjectsSliderDots'}
                                paginationClickable={true}
                                nextButton={'.SliderNextArrow'}
                                prevButton={'.SliderPrevArrow'}
                                spaceBetween={30}
                                slidesPerView={1}
                                loop={true}
                                onClick={(swiper, event) => {
                                    if (swiper.clickedSlide && swiper.clickedSlide.id) {
                                        const object = find(this.state.objects, { 'id': swiper.clickedSlide.id })
                                        if (object) {
                                            this.props.Popover.show(object)
                                        }
                                    }
                                }}
                                onTap={(swiper, event) => {
                                    if (swiper.clickedSlide && swiper.clickedSlide.id) {
                                        const object = find(this.state.objects, { 'id': swiper.clickedSlide.id })
                                        if (object) {
                                            this.props.Popover.show(object)
                                        }
                                    }
                                }}
                            >
                                {this.getObjectSlide()}
                            </Swiper>
                        ) : null}

                    </div>

                </div>
                <Lines opacity={1} color={'#9ccdfa'} />
            </div>
        )
    }
}

export default ObjectsSection


// WEBPACK FOOTER //
// ./src/Components/Sections/ObjectsSection.js